import React from 'react';
import { motion } from 'framer-motion';
import { Target, CheckCircle2 } from 'lucide-react';
export function TargetAudience() {
  const forWho = ['Kinesiólogos y fisioterapeutas', 'Médicos traumatólogos', 'Profesionales en rehabilitación', 'Estudiantes avanzados', 'Clínicas y centros de salud'];
  return <section className="py-12 px-4 bg-slate-900 border-y border-slate-800" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-950 p-5 md:p-8 rounded-2xl border border-teal-900/50 relative overflow-hidden" data-id="element-131">
          <div className="absolute top-0 right-0 w-32 h-32 bg-teal-500/10 rounded-full blur-2xl" data-id="element-132"></div>
          <div className="flex items-center gap-3 mb-5 relative z-10" data-id="element-133">
            <Target className="w-7 h-7 text-teal-400" data-id="element-134" />
            <h2 className="text-2xl font-bold text-white" data-id="element-135">¿Para quién es?</h2>
          </div>
          <ul className="space-y-3 mb-5 relative z-10" data-id="element-136">
            {forWho.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-137">
                <CheckCircle2 className="w-5 h-5 text-teal-500 flex-shrink-0" data-id="element-138" />
                <span className="text-slate-200 text-sm md:text-base" data-id="element-139">
                  {item}
                </span>
              </li>)}
          </ul>
          <div className="bg-teal-950/50 p-3 rounded-xl border border-teal-900 relative z-10" data-id="element-140">
            <p className="font-bold text-teal-400 text-center text-sm" data-id="element-141">
              👉 Si querés trabajar mejor, esto es para vos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}